// 在 src 目录下创建一个新的文件，如 ServiceWorkerContext.js
import { createContext } from 'react';

export const ServiceWorkerContext = createContext(null);